export default {
  getTax: state => taxType => {
    return state.taxes[taxType]
  }
}
